import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ListQuestionDataFilter } from 'types/campaign';

const initialState: ListQuestionDataFilter = [];

const questionDataFilterSlice = createSlice({
    name: 'questionDataFilter',
    initialState,
    reducers: {
        setListQuestionDataFilter: (
            state,
            action: PayloadAction<ListQuestionDataFilter>
        ) => {
            return action.payload;
        },
    },
});

export const { setListQuestionDataFilter } = questionDataFilterSlice.actions;

export default questionDataFilterSlice.reducer;
